module.exports = __webpack_public_path__ + "static/media/expert_symbol.890302f4.svg";